import { Box, Skeleton } from '@mui/material';

const SKELETON_WIDTHS = [40, 50, 90, 400, 80, 80, 100, 400, 80, 40, 60, 200];
const SKELETON_HEIGHTS = [0, 30, 60, 60, 60, 30, 30, 30, 60];

const SKELETON_ROW_HEIGHT = 16;
const SKELETON_ROW_GAP = 4;

const SKELETON_ROW_COUNT = 12;

export const ObjectDataViewerSkeleton = () => {
  return (
    <Box sx={{ p: 2, backgroundColor: 'jsonViewer.background' }}>
      <>
        {Array.from({ length: SKELETON_ROW_COUNT }).map((_, i) => (
          <Skeleton
            key={i}
            variant="rectangular"
            width={SKELETON_WIDTHS[i % SKELETON_WIDTHS.length]}
            height={SKELETON_ROW_HEIGHT}
            style={{
              marginBottom: SKELETON_ROW_GAP,
              marginLeft: SKELETON_HEIGHTS[i % SKELETON_HEIGHTS.length],
            }}
          />
        ))}
      </>
    </Box>
  );
};
